<script setup lang="ts">
import type { ContentNavigationItem } from '@nuxt/content'

const route = useRoute('onderzoek-slug___nl')

const { data: chapters } = await useAsyncData(`chapters-${route.params.slug}`, () => {
  return queryCollectionNavigation('investigationChapter').where('PATH', 'LIKE', `%${route.path}%`)
}, {
  default(): ContentNavigationItem[] {
    return []
  },
})

function getFirstChild(item: ContentNavigationItem) {
  if (item.children?.[0])
    return getFirstChild(item.children[0])

  return item
}

const surround = computed(() => {
  if (!chapters.value[0])
    return null

  return [null, getFirstChild(chapters.value[0])]
})
</script>

<template>
  <UContentSurround :surround="(surround as any)" />
</template>
